export default "__VITE_ASSET__892986c4__"